export const navigation = [
  {
    id: "0",
    title: "Home",
    url: "/",
  },
  {
    id: "1",
    title: "About",
    url: "/About",
  },
  {
    id: "2",
    title: "Portfolio",
    url: "/Portfolio",
  },
];
